import * as yup from 'yup';
import { FileFormFieldProps } from '../types';
import { isNil } from 'lodash';

const fileFormValidation = (fields: FileFormFieldProps[] | undefined) => {
    if (isNil(fields) || (fields && fields.length === 0)) {
        return yup.object().shape({});
    }

    const schema = yup.object().shape(
        fields!.reduce((acc, field) => {
            if (field.isRequired) {
                if (field.name === 'dateTo') {
                    return {
                        ...acc,
                        [field.name]: yup.date().when('common', {
                            is: (value: any) => {
                                // console.log('value', value);
                                return value !== 43;
                            },
                            then: (s) => {
                                // console.log('then');
                                return s.nullable().notRequired();
                            },
                            otherwise: (s) => {
                                // console.log('otherwise');
                                return s.required(`${field.label} is required`);
                            }
                        })
                        // .required(`${field.label} is required`)
                    };
                }
                return {
                    ...acc,
                    [field.name]: yup.string().required(`${field.label} is required`)
                };
            }
            return acc;
        }, {})
    );

    return schema;
};

export default fileFormValidation;
